module.exports = __webpack_public_path__ + "img/wendangguanli.f2a02a6c.png";